/**
 * Visibility - estado de visible/hidden para o aggregator (BEHAVIOR_SUMMARY ao ficar hidden).
 */

import type { VisibilityState } from './types';

let state: VisibilityState = {
  isVisible: true,
  visibleSince: 0,
  hiddenAt: null,
};

let visibilityListener: (() => void) | null = null;
let onVisibilityChange: ((s: VisibilityState) => void) | null = null;

function notify(): void {
  if (onVisibilityChange) onVisibilityChange({ ...state });
}

function handleVisibilityChange(): void {
  if (typeof document === 'undefined') return;
  const visible = document.visibilityState === 'visible';
  const now = Date.now();
  if (visible) {
    state = {
      isVisible: true,
      visibleSince: now,
      hiddenAt: null,
    };
  } else {
    state = {
      isVisible: false,
      visibleSince: state.visibleSince,
      hiddenAt: now,
    };
  }
  notify();
}

export function initVisibilityBehavior(
  callback?: (s: VisibilityState) => void
): void {
  if (typeof document === 'undefined') return;
  onVisibilityChange = callback ?? null;
  const now = Date.now();
  state = {
    isVisible: document.visibilityState === 'visible',
    visibleSince: now,
    hiddenAt: document.visibilityState === 'hidden' ? now : null,
  };

  if (visibilityListener) {
    document.removeEventListener('visibilitychange', visibilityListener);
  }
  visibilityListener = handleVisibilityChange;
  document.addEventListener('visibilitychange', visibilityListener);
  notify();
}

export function getVisibilityState(): VisibilityState {
  return { ...state };
}

export function resetVisibilityState(): void {
  const now = Date.now();
  state = {
    isVisible:
      typeof document !== 'undefined' && document.visibilityState === 'visible',
    visibleSince: now,
    hiddenAt: null,
  };
  notify();
}

export function destroyVisibilityBehavior(): void {
  if (visibilityListener && typeof document !== 'undefined') {
    document.removeEventListener('visibilitychange', visibilityListener);
  }
  visibilityListener = null;
  onVisibilityChange = null;
}
